import { getApi } from "../apis";

export const fetchColorPalette = () => {
    return getApi(`random?number=${52}`)
}

export const fetchSpecificPalette = (colorName) => {
    return getApi(`random/${colorName}?number=${52}`)
}